import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class EmpresasEnvioService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/empresas-de-envio/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/mafe-dev/src/app/shared/services/api/empresas-envio.service.ts